import { useCallback, useState } from 'react';
import { STAGE_DEADLINE, type DeadlineField } from '@stages/stages';
import type { ProjectDeadlines } from '@/api/client';
import { projectReviewDeadlineToDisplay } from '@/utils/emailDateUtils';

/** Срок, который уходит в письме «Передать в производство» по умолчанию — «Завершить производство до» */
export const DEFAULT_HANDOFF_DEADLINE_FIELD: DeadlineField = STAGE_DEADLINE['Готов'].field;

/**
 * Срок письма «Передать в производство»: какой из сроков этапов и его дата (дд.мм.гггг).
 * Смена срока подставляет в дату сохранённое значение этого поля проекта.
 */
export function useProductionHandoffDeadline(project: ProjectDeadlines) {
  const [deadlineField, setDeadlineField] = useState<DeadlineField>(DEFAULT_HANDOFF_DEADLINE_FIELD);
  const [deadlineDate, setDeadlineDate] = useState('');

  const selectField = useCallback(
    (field: DeadlineField) => {
      setDeadlineField(field);
      setDeadlineDate(projectReviewDeadlineToDisplay(project[field]));
    },
    [project]
  );

  const reset = useCallback(() => selectField(DEFAULT_HANDOFF_DEADLINE_FIELD), [selectField]);

  return { deadlineField, deadlineDate, setDeadlineDate, selectField, reset };
}
